import { Sparkles } from "lucide-react";
import { Input } from "../ui/input";

const PRESETS = ["#4F46E5", "#DB2777", "#059669", "#EA580C", "#0EA5E9", "#0F172A"];
const POSITIONS = [
  { key: "diagonal", label: "Diagonal" },
  { key: "center", label: "Center" },
  { key: "tiled", label: "Tiled" },
  { key: "footer", label: "Footer" },
];

export default function BrandingBar({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const opacity = value.watermark_opacity ?? 0.12;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 mb-4 space-y-3">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-center gap-2 text-sm font-medium text-slate-700 shrink-0">
          <Sparkles className="h-4 w-4 text-indigo-600" /> Branding
        </div>
        <div className="flex-1 flex flex-col sm:flex-row gap-3 sm:items-center">
          <Input
            data-testid="branding-watermark-input"
            value={value.watermark || ""}
            onChange={(e) => set({ watermark: e.target.value })}
            placeholder="Watermark text (optional) e.g. DRAFT"
            className="bg-white sm:max-w-xs"
          />
          <div className="flex items-center gap-2">
            <span className="text-xs text-slate-500">Color</span>
            {PRESETS.map((c) => (
              <button
                key={c}
                type="button"
                data-testid={`branding-color-${c.replace("#", "")}`}
                onClick={() => set({ brand_color: c })}
                className={`h-6 w-6 rounded-full border-2 transition ${value.brand_color === c ? "border-slate-900 scale-110" : "border-white ring-1 ring-slate-200"}`}
                style={{ backgroundColor: c }}
                aria-label={`Brand color ${c}`}
              />
            ))}
            <input
              data-testid="branding-color-input"
              type="color"
              value={value.brand_color || "#4F46E5"}
              onChange={(e) => set({ brand_color: e.target.value })}
              className="h-6 w-8 rounded cursor-pointer border border-slate-200 bg-white"
            />
          </div>
        </div>
      </div>

      {value.watermark ? (
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 pt-1 border-t border-slate-100">
          <div className="flex items-center gap-1.5">
            <span className="text-xs text-slate-500 mr-1">Style</span>
            {POSITIONS.map((p) => (
              <button
                key={p.key}
                type="button"
                data-testid={`watermark-position-${p.key}`}
                onClick={() => set({ watermark_position: p.key })}
                className={`px-2.5 py-1 rounded-full text-xs font-medium transition-colors ${
                  (value.watermark_position || "diagonal") === p.key ? "bg-indigo-600 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                {p.label}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-2 flex-1 sm:max-w-xs">
            <span className="text-xs text-slate-500">Opacity</span>
            <input
              data-testid="watermark-opacity-slider"
              type="range"
              min="0.05"
              max="0.4"
              step="0.01"
              value={opacity}
              onChange={(e) => set({ watermark_opacity: parseFloat(e.target.value) })}
              className="flex-1 accent-indigo-600"
            />
            <span className="text-xs font-mono text-slate-500 w-8">{Math.round(opacity * 100)}%</span>
          </div>
        </div>
      ) : null}
    </div>
  );
}
